import React from 'react';
import { TooltipListInput, type TooltipItem } from './TooltipListInput';

interface TooltipListFieldProps {
  label: string;
  required?: boolean;
  value: TooltipItem[];
  onChange: (_items: TooltipItem[]) => void;
  error?: string;
}

export const TooltipListField: React.FC<TooltipListFieldProps> = ({
  label,
  required,
  value,
  onChange,
  error,
}) => {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <TooltipListInput value={value ?? []} onChange={onChange} />
      {error && <p className="text-red-500 text-sm">{error}</p>}
    </div>
  );
};
